import React from 'react';
import SvgFavoritesFilled from '@components/icons/FavoritesFilled.tsx';
import SvgFavorites from '@components/icons/Favorites.tsx';
import { IconWrapper } from '@components/icons/IconWrapper.tsx';

interface ComponentProps {
  isFavorite: boolean;
  favoriteLoading: boolean;
  onFavoriteClick: (e: any) => void;
  className: string;
}

const FavoritesIcon: React.FC<ComponentProps> = ({ isFavorite, favoriteLoading, onFavoriteClick, className = 'h-[20px] w-[20px]' }) => {
  return (
    <>
      <IconWrapper className={`${className} text-controls-surface-dark-secondary-default fill-black`} onClick={e => onFavoriteClick(e)}>
        {isFavorite ? <SvgFavoritesFilled className={favoriteLoading ? 'animate-spin' : ''} /> : <SvgFavorites className={favoriteLoading ? 'animate-spin' : ''} />}
      </IconWrapper>
    </>
  );
};

export default FavoritesIcon;
